import React from "react";
interface IconRequestProps {
  className?: string;
  width?: number;
  fill?: string;
}

const IconRequest: React.FC<IconRequestProps> = ({ className, width }) => (
  <svg
    className={className}
    width={width}
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.64">
      <mask
        id="mask0_23_3350"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="0"
        width="42"
        height="43"
      >
        <rect
          x="1.23389"
          y="0.547607"
          width="41.5303"
          height="41.5303"
          fill="#ffffff"
        />
      </mask>
      <g mask="url(#mask0_23_3350)">
        <path
          d="M9.66961 16.6406L15.0772 13.6556L15.0608 31.3451C14.4551 31.4028 14.0169 32.7087 13.1836 32.4743C12.3291 32.1461 12.2296 31.4701 11.6157 31.2389L11.6163 19.5391L9.84265 20.4908C9.43888 20.7215 9.00628 20.772 8.54483 20.6422C8.08338 20.5124 7.73729 20.2457 7.50657 19.8419L4.04571 13.8286C3.81499 13.4249 3.76452 12.9851 3.8943 12.5092C4.02408 12.0333 4.29086 11.68 4.69462 11.4493L13.3035 6.47432C13.6496 6.27244 14.0101 6.0994 14.385 5.9552C14.76 5.81099 15.1493 5.73889 15.5531 5.73889C15.9568 5.73889 16.3029 5.86146 16.5913 6.10661C16.8797 6.35175 17.096 6.66179 17.2402 7.03671C17.644 8.13265 18.1703 9.05555 18.8192 9.8054C19.4682 10.5553 20.528 10.9302 21.9989 10.9302C23.4698 10.9302 24.5297 10.5553 25.1786 9.8054C25.8275 9.05555 26.3538 8.13265 26.7576 7.03671C26.9018 6.66179 27.1253 6.35175 27.4281 6.10661C27.731 5.86146 28.0842 5.73889 28.488 5.73889C28.8918 5.73889 29.2739 5.81099 29.6344 5.9552C29.9949 6.0994 30.3482 6.27244 30.6943 6.47432L39.3032 11.4493C39.707 11.68 39.9665 12.0261 40.0819 12.4876C40.1972 12.949 40.1396 13.3816 39.9088 13.7854L36.4912 19.8419C36.2605 20.2457 35.9144 20.5124 35.453 20.6422C34.9915 20.772 34.5589 20.7215 34.1552 20.4908L32.3815 19.5391V34.7668L29.6561 35.4157C29.5407 35.5023 29.4253 35.5816 29.31 35.6537C29.1946 35.7258 29.0648 35.7907 28.9206 35.8483V13.6556L34.3282 16.6406L36.0586 13.6123L29.4398 9.76214C28.7476 11.1753 27.731 12.3001 26.3899 13.1365C25.0488 13.9728 23.5851 14.391 21.9989 14.391C20.4127 14.391 18.949 13.9728 17.6079 13.1365C16.2669 12.3001 15.2502 11.1753 14.5581 9.76214L7.89592 13.6123L9.66961 16.6406Z"
          fill="#21222D"
        />
      </g>
      <path
        d="M6.02274 27.5085C5.59895 27.9549 4.38565 30.9581 6.91264 33.468C9.87896 36.4143 15.2925 37.4856 21.6333 37.3874C33.1681 37.2087 36.6812 32.8893 36.9475 30.2404C37.0254 29.4657 36.7964 27.2166 34.6943 26.1511"
        stroke="#21222D"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <path
        d="M1.96338 28.3455L5.47213 24.5316L8.95635 28.342"
        stroke="#21222D"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3442 27.3068V31.4309"
        stroke="#21222D"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default IconRequest;
